import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { PAYMENT_REQUEST_BASE_ROUTES } from './payment-request-base.routes';

export const PAYMENT_REQUESTS_PAYMENT_REQUEST_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...PAYMENT_REQUEST_BASE_ROUTES];
    routesService.add(routes);
  };
}
